import { SvgIcon } from "@mui/material";
export var AddIconSVG = function (props) {
    return /*#__PURE__*/ React.createElement(SvgIcon, props, /*#__PURE__*/ React.createElement("svg", {
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M7.0013 1.16675V12.8334M1.16797 7.00008H12.8346",
        stroke: "white",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
    })));
};
export var BackgroundPWSVG = function (props) {
    return /*#__PURE__*/ React.createElement(SvgIcon, props, /*#__PURE__*/ React.createElement("svg", {
        width: "167",
        height: "88",
        viewBox: "0 0 167 88",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M160 1C163.866 1 167 4.13401 167 8C167 11.866 163.866 15 160 15H120C123.866 15 127 18.134 127 22C127 25.866 123.866 29 120 29H142C145.866 29 149 32.134 149 36C149 39.866 145.866 43 142 43H131.826C126.952 43 123 46.134 123 50C123 52.5773 125 54.9107 129 57C132.866 57 136 60.134 136 64C136 67.866 132.866 71 129 71H46C42.134 71 39 67.866 39 64C39 60.134 42.134 57 46 57H7C3.13401 57 0 53.866 0 50C0 46.134 3.13401 43 7 43H47C50.866 43 54 39.866 54 36C54 32.134 50.866 29 47 29H22C18.134 29 15 25.866 15 22C15 18.134 18.134 15 22 15H62C58.134 15 55 11.866 55 8C55 4.13401 58.134 1 62 1H160ZM160 29C163.866 29 167 32.134 167 36C167 39.866 163.866 43 160 43C156.134 43 153 39.866 153 36C153 32.134 156.134 29 160 29Z",
        fill: "#EEF6FF"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M73.5 69C92.0015 69 107 54.0015 107 35.5C107 16.9985 92.0015 2 73.5 2C54.9985 2 40 16.9985 40 35.5C40 54.0015 54.9985 69 73.5 69Z",
        fill: "#EEF6FF",
        stroke: "#2B79CC",
        "stroke-width": "2.5"
    }), /*#__PURE__*/ React.createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M68.1321 61.4939C69.8908 61.8185 71.6801 61.9872 73.5 62C88.1355 62 100 50.1355 100 35.5C100 20.8645 88.1355 9 73.5 9C69.7404 9 66.1636 9.78293 62.9238 11.1946C57.2938 13.6479 52.6816 17.9999 49.896 23.4419C48.0445 27.0589 47 31.1575 47 35.5C47 39.44 47.8599 43.1792 49.4021 46.5401C50.5032 48.9396 51.9521 51.1463 53.6843 53.0956",
        fill: "white"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M68.1321 61.4939C69.8908 61.8185 71.6801 61.9872 73.5 62C88.1355 62 100 50.1355 100 35.5C100 20.8645 88.1355 9 73.5 9C69.7404 9 66.1636 9.78293 62.9238 11.1946C57.2938 13.6479 52.6816 17.9999 49.896 23.4419C48.0445 27.0589 47 31.1575 47 35.5C47 39.44 47.8599 43.1792 49.4021 46.5401C50.5032 48.9396 51.9521 51.1463 53.6843 53.0956",
        stroke: "#2B79CC",
        "stroke-width": "2.5",
        "stroke-linecap": "round"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M56.7974 56.0747C58.9455 57.8207 61.3723 59.237 64.0008 60.2466",
        stroke: "#2B79CC",
        "stroke-width": "2.5",
        "stroke-linecap": "round"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M101 62L107 68",
        stroke: "#2B79CC",
        "stroke-width": "2.5"
    }), /*#__PURE__*/ React.createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M106.03 67.0303C104.138 68.923 104.138 71.9917 106.03 73.8844L117.116 84.9697C119.008 86.8625 122.077 86.8625 123.97 84.9697C125.863 83.077 125.863 80.0083 123.97 78.1156L112.885 67.0303C110.992 65.1376 107.923 65.1376 106.03 67.0303Z",
        fill: "#EEF6FF",
        stroke: "#2B79CC",
        "stroke-width": "2.5"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M111 69L122 80",
        stroke: "white",
        "stroke-width": "2.5",
        "stroke-linecap": "round"
    }), /*#__PURE__*/ React.createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M67 24C67 35.598 76.4021 45 88 45C90.2784 45 92.472 44.6372 94.5262 43.9662C91.1732 52.2871 83.0225 58.1607 73.5 58.1607C60.9849 58.1607 50.8394 48.0152 50.8394 35.5C50.8394 24.1596 59.1697 14.7648 70.045 13.1011C68.113 16.2793 67 20.0097 67 24Z",
        fill: "#EEF6FF"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M74 17C72.7266 17 71.4825 17.1253 70.2793 17.3642M66.6447 18.4761C59.8039 21.3508 55 28.1144 55 36",
        stroke: "#3697FF",
        "stroke-width": "2.5",
        "stroke-linecap": "round"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M127.176 35.7773H119M133.5 28H116.324H133.5ZM140.5 28H138.279H140.5Z",
        stroke: "#3697FF",
        "stroke-width": "2.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M32.5 49H15.3242M9.5 49H5.27881M37.1758 57.7773H29",
        stroke: "#3697FF",
        "stroke-width": "2.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
    })));
};
export var VerifiedSVG = function (props) {
    return /*#__PURE__*/ React.createElement(SvgIcon, props, /*#__PURE__*/ React.createElement("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M1.01575 6C1.0156 5.93309 1.00246 5.86625 0.976325 5.80326L0.615605 4.92988C0.539397 4.74594 0.500032 4.54849 0.5 4.3494C0.499968 4.15019 0.539188 3.95293 0.615419 3.76888C0.691651 3.58484 0.803399 3.41761 0.944281 3.27677C1.08512 3.13597 1.25233 3.02429 1.43633 2.94811L2.3083 2.58692C2.43458 2.5347 2.5353 2.43443 2.58787 2.3083L2.94915 1.43607C3.10304 1.06453 3.39822 0.76933 3.76976 0.615427C4.1413 0.461524 4.55876 0.461524 4.93031 0.615427L5.80186 0.976452C5.92834 1.02867 6.07051 1.0286 6.19689 0.976155L6.19788 0.975744L7.07021 0.615958C7.44162 0.462265 7.85917 0.462214 8.23054 0.616046C8.60201 0.769918 8.89715 1.06503 9.05106 1.43648L9.40367 2.28776C9.4068 2.29448 9.40979 2.3013 9.41265 2.30821C9.46492 2.43462 9.56521 2.53512 9.6915 2.58765L10.564 2.94905C10.9355 3.10295 11.2307 3.39815 11.3846 3.76969C11.5385 4.14124 11.5385 4.5587 11.3846 4.93024L11.0234 5.80224C10.9972 5.86557 10.9841 5.93304 10.984 6.00015C10.9841 6.06726 10.9972 6.13443 11.0234 6.19776L11.3846 7.06976C11.5385 7.4413 11.5385 7.85876 11.3846 8.23031C11.2307 8.60185 10.9355 8.89705 10.564 9.05095L9.6915 9.41235C9.56521 9.46488 9.46492 9.56538 9.41265 9.69179C9.40979 9.6987 9.4068 9.70552 9.40367 9.71224L9.05106 10.5635C8.89715 10.935 8.60201 11.2301 8.23054 11.384C7.85917 11.5378 7.44162 11.5377 7.07021 11.384L6.19788 11.0243L6.19689 11.0238C6.07051 10.9714 5.92834 10.9713 5.80186 11.0235L4.93031 11.3846C4.55876 11.5385 4.1413 11.5385 3.76976 11.3846C3.39822 11.2307 3.10304 10.9355 2.94915 10.5639L2.58787 9.6917C2.5353 9.56557 2.43458 9.4653 2.3083 9.41308L1.43633 9.05189C1.25233 8.97571 1.08512 8.86403 0.944281 8.72323C0.803399 8.58239 0.691651 8.41516 0.615419 8.23112C0.539188 8.04707 0.499968 7.84981 0.5 7.6506C0.500032 7.45151 0.539397 7.25406 0.615605 7.07012L0.976325 6.19674C1.00246 6.13375 1.0156 6.06691 1.01575 6ZM8.10355 5.10355C8.29882 4.90829 8.29882 4.59171 8.10355 4.39645C7.90829 4.20118 7.59171 4.20118 7.39645 4.39645L5.5 6.29289L4.85355 5.64645C4.65829 5.45118 4.34171 5.45118 4.14645 5.64645C3.95118 5.84171 3.95118 6.15829 4.14645 6.35355L5.14645 7.35355C5.34171 7.54882 5.65829 7.54882 5.85355 7.35355L8.10355 5.10355Z",
        fill: "#3697FF"
    })));
};
export var MailOutlineSVG = function (props) {
    return /*#__PURE__*/ React.createElement(SvgIcon, props, /*#__PURE__*/ React.createElement("svg", {
        width: "14",
        height: "12",
        viewBox: "0 0 14 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M1.16797 3.08337L5.93084 6.41738C6.31652 6.68736 6.50936 6.82235 6.71912 6.87464C6.90441 6.92082 7.0982 6.92082 7.28348 6.87464C7.49324 6.82235 7.68608 6.68736 8.07176 6.41738L12.8346 3.08337M3.96797 10.6667H10.0346C11.0147 10.6667 11.5048 10.6667 11.8791 10.476C12.2084 10.3082 12.4761 10.0405 12.6439 9.71119C12.8346 9.33685 12.8346 8.8468 12.8346 7.86671V4.13337C12.8346 3.15328 12.8346 2.66324 12.6439 2.28889C12.4761 1.95961 12.2084 1.69189 11.8791 1.52411C11.5048 1.33337 11.0147 1.33337 10.0346 1.33337H3.96797C2.98788 1.33337 2.49783 1.33337 2.12349 1.52411C1.7942 1.69189 1.52649 1.95961 1.35871 2.28889C1.16797 2.66324 1.16797 3.15328 1.16797 4.13337V7.86671C1.16797 8.8468 1.16797 9.33685 1.35871 9.71119C1.52649 10.0405 1.7942 10.3082 2.12349 10.476C2.49783 10.6667 2.98788 10.6667 3.96797 10.6667Z",
        stroke: "#8593A3",
        "stroke-width": "1.3",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
    })));
};
export var AddressMapSVG = function (props) {
    return /*#__PURE__*/ React.createElement(SvgIcon, props, /*#__PURE__*/ React.createElement("svg", {
        width: "16",
        height: "20",
        viewBox: "0 0 16 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M8.00008 10.6666C9.10465 10.6666 10.0001 9.77115 10.0001 8.66659C10.0001 7.56202 9.10465 6.66659 8.00008 6.66659C6.89551 6.66659 6.00008 7.56202 6.00008 8.66659C6.00008 9.77115 6.89551 10.6666 8.00008 10.6666Z",
        stroke: "#8593A3",
        "stroke-width": "1.3",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M8.00008 16.6666C10.6667 13.9999 13.3334 11.6121 13.3334 8.66659C13.3334 5.72107 10.9456 3.33325 8.00008 3.33325C5.05456 3.33325 2.66675 5.72107 2.66675 8.66659C2.66675 11.6121 5.33341 13.9999 8.00008 16.6666Z",
        stroke: "#8593A3",
        "stroke-width": "1.3",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
    })));
};
export var MenuIconSVG = function (props) {
    return /*#__PURE__*/ React.createElement(SvgIcon, props, /*#__PURE__*/ React.createElement("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M7.5 9C7.5 8.17157 8.17157 7.5 9 7.5C9.82843 7.5 10.5 8.17157 10.5 9C10.5 9.82843 9.82843 10.5 9 10.5C8.17157 10.5 7.5 9.82843 7.5 9Z",
        fill: "#6A7682"
    }), /*#__PURE__*/ React.createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M7.5 3.75C7.5 2.92157 8.17157 2.25 9 2.25C9.82843 2.25 10.5 2.92157 10.5 3.75C10.5 4.57843 9.82843 5.25 9 5.25C8.17157 5.25 7.5 4.57843 7.5 3.75Z",
        fill: "#6A7682"
    }), /*#__PURE__*/ React.createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M7.5 14.25C7.5 13.4216 8.17157 12.75 9 12.75C9.82843 12.75 10.5 13.4216 10.5 14.25C10.5 15.0784 9.82843 15.75 9 15.75C8.17157 15.75 7.5 15.0784 7.5 14.25Z",
        fill: "#6A7682"
    })));
};
export var CallIconSVG = function (props) {
    return /*#__PURE__*/ React.createElement(SvgIcon, props, /*#__PURE__*/ React.createElement("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M6.98356 7.37779C7.56356 8.58581 8.35422 9.71801 9.35553 10.7193C10.3568 11.7206 11.4891 12.5113 12.6971 13.0913C12.801 13.1412 12.8529 13.1661 12.9187 13.1853C13.1523 13.2534 13.4392 13.2045 13.637 13.0628C13.6927 13.0229 13.7403 12.9753 13.8356 12.88C14.1269 12.5887 14.2726 12.443 14.4191 12.3478C14.9715 11.9886 15.6837 11.9886 16.2361 12.3478C16.3825 12.443 16.5282 12.5887 16.8196 12.88L16.9819 13.0424C17.4248 13.4853 17.6462 13.7067 17.7665 13.9446C18.0058 14.4175 18.0058 14.9761 17.7665 15.449C17.6462 15.6869 17.4248 15.9083 16.9819 16.3512L16.8506 16.4825C16.4092 16.9239 16.1886 17.1446 15.8885 17.3131C15.5556 17.5001 15.0385 17.6346 14.6567 17.6334C14.3126 17.6324 14.0774 17.5657 13.607 17.4322C11.0792 16.7147 8.69387 15.361 6.70388 13.371C4.7139 11.381 3.36017 8.99569 2.6427 6.46786C2.50919 5.99749 2.44244 5.7623 2.44141 5.41818C2.44028 5.03633 2.57475 4.51925 2.76176 4.18633C2.9303 3.88631 3.15098 3.66563 3.59233 3.22428L3.72369 3.09292C4.16656 2.65005 4.388 2.42861 4.62581 2.30833C5.09878 2.0691 5.65734 2.0691 6.1303 2.30832C6.36812 2.42861 6.58955 2.65005 7.03242 3.09291L7.19481 3.25531C7.48615 3.54665 7.63182 3.69231 7.72706 3.8388C8.08622 4.3912 8.08622 5.10336 7.72706 5.65576C7.63182 5.80225 7.48615 5.94791 7.19481 6.23925C7.09955 6.33451 7.05192 6.38214 7.01206 6.43782C6.87038 6.63568 6.82146 6.92256 6.88957 7.15619C6.90873 7.22193 6.93367 7.27389 6.98356 7.37779Z",
        stroke: "#EB6A2C",
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
    })));
};
